/* istanbul ignore file */
import { Platform } from 'core/common/entities';
import { AppEnvironment } from 'core/common/services';

export class AppServerEnvironment implements AppEnvironment {
  isTestingEnv() {
    return false;
  }

  getSplitId() {
    return '';
  }

  isAndroid(userAgent?: string) {
    if (!userAgent) return false;

    return !!userAgent.match(/android/i);
  }

  isSafari(userAgent?: string) {
    if (!userAgent) return false;

    return !!userAgent.match(/Version\/[\d\\.]+.*Safari/);
  }

  isAppleMobile(userAgent?: string) {
    if (!userAgent) return false;

    return !!userAgent.match(/iPhone|iPad|iPod/i);
  }

  isApple(userAgent?: string) {
    if (!userAgent) return false;

    return userAgent.search(/OS X|iPhone|iPad|iOS/i) !== -1;
  }

  isApplePaySupported(userAgent?: string) {
    return this.isSafari(userAgent) || this.isAppleMobile(userAgent);
  }

  isMobileDevice(userAgent?: string) {
    if (!userAgent) return false;

    const mobileKeywords = [
      'Android',
      'webOS',
      'iPhone',
      'iPad',
      'iPod',
      'BlackBerry',
      'Windows Phone',
      'IEMobile',
      'Opera Mini',
    ];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }

  isInAppBrowser() {
    return false;
  }

  getPlatform(userAgent?: string): Platform {
    if (this.isAndroid(userAgent)) return Platform.ANDROID;

    if (this.isAppleMobile(userAgent)) return Platform.IOS;

    return Platform.UNKNOWN;
  }

  getUserAgent() {
    return '';
  }

  getDeviceLanguage() {
    return '';
  }

  getProjectName() {
    return '';
  }
}
